var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#545454",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.47 4.94 9.53 4l-4 4 4 4 .94-.94L7.417 8l3.053-3.06z",
    fill: "{fill}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateBack);
export default __webpack_public_path__ + "static/media/navigateBack.d9e85693820fb7454a866cd2c1edb239.svg";
export { ForwardRef as ReactComponent };